// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68668d60","662":"f21f04ba","958":"0c4ec6e1"}[chunkId] + ".chunk.js";
};